import 'intersection-observer'
import Vue from 'vue'
import VueRouter from 'vue-router'
import Snotify from 'vue-snotify'
import VueForm from 'vue-form'
import axios from 'axios'
import VueAnalytics from 'vue-analytics'
import _ from 'lodash'
import VueLocalStorage from 'vue-localstorage'
import VueSlider from 'vue-slider-component'
import VueEasyLightbox from 'vue-easy-lightbox'

import vueBodyClass from './VueBodyClass'

import 'vue-slider-component/theme/default.css'
import './main.css'

Vue.use(VueRouter)
Vue.use(Snotify)
Vue.use(VueForm)
Vue.use(VueLocalStorage)

Vue.component('VueSlider', VueSlider)
Vue.component('VueEasyLightbox', VueEasyLightbox)

import store from './store'

import App from './App'
import Home from './components/Home'
import Login from './components/Login'
import Logout from './components/Logout'
import Dashboard from './components/Dashboard'
import DashboardContainer from './components/DashboardContainer'
import ViewAlbumContainer from './components/ViewAlbumContainer'
import ViewContainer from './components/ViewContainer'
import PageNotFound from './components/PageNotFound'
import AlbumMaster from './components/AlbumMaster'
import Layout from './components/Layout'
import About from './components/About'
import Contact from './components/Contact'
import Profile from './components/Profile'
import ProfileEdit from './components/ProfileEdit'
import ViewProfileContainer from './components/ViewProfileContainer'

Vue.config.productionTip = false

const checkLoggedIn = (to, from, next) => {
  if (store.state.user) {
    return next()
  }
  axios.get('/auth/me').then(response => {
    const user = response.data.user
    if (user) {
      store.commit('setUser', user)
      next()
    } else {
      store.commit('setUserFail', { message: 'You must login to access this page' })
      next()
    }
  }).catch(error => {
    console.log('--------------------- error', error)
    store.commit('setUserFail', error)
    next('/login')
  })
}

const getLoggedIn = (to, from, next) => {
  // Here, we immediately call next, so the routes can be drawn, without waiting for the axios response.
  next()
  axios.get('/auth/me').then(response => {
    const user = response.data.user
    if (user) {
      store.commit('setUser', user)
    }
  }).catch(() => {
    // We don't care.
  })
}

// Reminder: when I wrote this, I thought it would help. It works, but I realized that it doesn't actually help my situation
// because I want the pageId as a Number in PageMaster, but in AlbumEdit I pass it in as a String because I grab it from
// the route params. Ideally the props that I return here would OVERWRITE the params, or there would be some way to access
// the values created here when using $route later on, but I don't know of any such way. I ended up solving my immediate
// problem by simply setting the prop type of id to a union type of [Number, String] in PageMaster. But it'd be nicer
// to know it's a Number.
//
// My version, inspired by https://stackoverflow.com/a/63897213/135101
function paramsToPropsCaster(route) {
  return _.mapValues(route.params, (v, k) => {
    if (k === 'id' || k.endsWith('Id')) {
      return parseInt(v, 10)
    }
    return v
  })
}

const routes = [
  { name: 'home', path: '/', component: Home, beforeEnter: checkLoggedIn, meta: { bodyClass: 'home' } },
  { path: '', component: Layout, beforeEnter: getLoggedIn, children: [
    { name: 'about', path: '/about', component: About },
    { name: 'contact', path: '/contact', component: Contact },
  ]},
  { path: '/login', component: Login },
  { path: '/logout', component: Logout },
  { path: '/dashboard', component: DashboardContainer, beforeEnter: checkLoggedIn, children: [
    { name: 'dashboard', path: '', component: Dashboard },
    { path: 'albums', redirect: '/dashboard' },
    { name: 'albumPages', path: 'albums/:id/:slug/pages', component: AlbumMaster, props: true },
    { name: 'albumPagesEdit', path: 'albums/:id/:slug/pages/edit', component: AlbumMaster, props: true },
    { name: 'albumEdit', path: 'albums/:id/:slug/edit', component: AlbumMaster, props: true },
    { name: 'albumShare', path: 'albums/:id/:slug/share', component: AlbumMaster, props: true },
    { name: 'pageEdit', path: 'albums/:id/:slug/pages/:pageId/edit', component: AlbumMaster, props: paramsToPropsCaster },
  ]},
  { path: '', component: DashboardContainer, beforeEnter: checkLoggedIn, children: [
    { name: 'profile', path: 'profile', component: Profile },
    { name: 'profileEdit', path: 'profile/edit', component: ProfileEdit },
  ]},
  { path: '/albums', component: ViewContainer, children: [
    { name: 'viewAlbum', path: ':id/:slug', component: ViewAlbumContainer, props: true },
    { name: 'viewPage', path: ':id/:slug/pages/:pageId', component: ViewAlbumContainer, props: true },
  ]},
  { path: '/users', component: ViewContainer, children: [
    { name: 'viewProfile', path: ':id/:username', component: ViewProfileContainer },
  ]},
  { path: '*', component: PageNotFound }
]

const router = new VueRouter({
  mode: 'history',
  routes,
})
Vue.use(vueBodyClass, router)
if (process.env.GOOGLE_ANALYTICS_TRACKING_ID) {
  Vue.use(VueAnalytics, {
    id: process.env.GOOGLE_ANALYTICS_TRACKING_ID,
    router,
  })
}

new Vue({
  render: h => h(App),
  router,
  store,
}).$mount('#app')

